import axios from 'axios';
import { Users_Cuentas } from 'generated/graphql';

export interface IMonitorName {
	key: string;
	tipoUsuario: string;
	rol: string;
	email: string;
	password: string;
	nombre: string;
	apellido: string;
	rut: string | null;
	fechaNacimiento: Date | null;
	genero: string | null;
	avatarPath: string | null;
	pais: string;
	institucion: string;
}

export const fetchGetMonitorDetail = async (monitorKey: string, isPWA?: boolean): Promise<Users_Cuentas> => {
	const url = `${process.env.REACT_APP_NEST_BACKEND_URL}/monitor/detail/${monitorKey}${
		isPWA !== undefined ? `?isPWA=${isPWA}` : ''
	}`;
	const resp = await axios.get(url);
	return resp.data;
};

export const fetchGetMonitorName = async (monitorKey: string): Promise<IMonitorName> => {
	const resp = await axios.get(`${process.env.REACT_APP_NEST_BACKEND_URL}/monitor/${monitorKey}`);
	return resp.data;
};
